<template>

  <div class="benefits mt-3 mb-3  benefits--mobile">
    <div v-for="benefit in benefit_banners" class="benefits__item">
      <img :src="benefit.mobile_image.webp" :srcset="benefit.mobile_image.source" data-sizes="auto" width="25" height="25" class="benefits__icon lazyload" :alt="benefit.title">
      <div class="benefits__text">
        <a :href="benefit.link" :title="benefit.title">
          <span v-html="benefit.title"></span>
        </a>
      </div>
    </div>
  </div>

  <div class="benefits mt-3 mb-3  hide-md">
    <div v-for="(benefit, index) in benefit_banners" class="benefits__item">
      <img :src="benefit.desktop_image.webp" :srcset="benefit.desktop_image.source" data-sizes="auto" width="25" height="25" class="benefits__icon lazyload" :alt="benefit.title">
      <div class="benefits__text">
        <a :href="benefit.link" :title="benefit.title">
          <span v-html="benefit.title"></span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name:  "Benefits",
  props: [
    'benefit_banners',
  ],
}
</script>
